import api, { ApiResponse } from './api'
import type { MerchantPaymentMethod, MerchantPaymentMethodListResponse, PaymentMethod } from '../types'

function requireBindingId(bindingId: string): string {
  if (typeof bindingId !== 'string' || !bindingId.trim()) {
    throw new Error('Payment method bindingId is required')
  }
  return bindingId
}

export function listPaymentMethods(): Promise<ApiResponse<MerchantPaymentMethodListResponse>> {
  return api.get('/v1/merchant/payment-methods')
}

export function updatePaymentMethodStatus(
  paymentMethod: PaymentMethod,
  enabled: boolean,
  bindingId: string
): Promise<ApiResponse<MerchantPaymentMethod>> {
  return api.patch(`/v1/merchant/payment-methods/${paymentMethod}/status`, {
    enabled,
    bindingId: requireBindingId(bindingId),
  })
}

export function updatePaymentMethodFeeSharing(
  paymentMethod: PaymentMethod,
  data: {
    customerFeeRate: string
    customerPerTransactionFee: string
    checkoutDisplayText?: string
    bindingId: string
  }
): Promise<ApiResponse<MerchantPaymentMethod>> {
  return api.patch(`/v1/merchant/payment-methods/${paymentMethod}/fee-sharing`, {
    customerFeeRate: data.customerFeeRate,
    customerPerTransactionFee: data.customerPerTransactionFee,
    checkoutDisplayText: data.checkoutDisplayText,
    bindingId: requireBindingId(data.bindingId),
  })
}
